import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { TComplainCategory } from "apis/complain";
import { useEffect, useState } from "react";

type ComplainCategoryProps = {
  idx: number;
  onChange?: (index: number, value: string) => void;
  onDelete?: (index: number) => void;
  category?: TComplainCategory;
};
const ComplainCategory = ({ idx, onChange, onDelete, category }: ComplainCategoryProps) => {
  const [canEdit, setCanEdit] = useState<boolean>(false);
  const [cateogryName, setCategoryName] = useState<string>("");

  const onChangeCategoryField = (value: string) => {
    setCategoryName(value);
    onChange?.(idx, value);
  };

  useEffect(() => {
    if (!category?.id) {
      setCanEdit(true);
    }
  }, []);

  useEffect(() => {
    setCategoryName(category?.content ?? "");
  }, [category]);

  return (
    <Container>
      <UI.Input
        width={"100%"}
        value={cateogryName}
        disabled={!canEdit}
        onChange={onChangeCategoryField}
      />
      <ButtonContainer>
        <UI.IconButton.Background 
          icon="modify" 
          type="secondary"
          onClick={() => {setCanEdit(true)}}
        />
        <UI.IconButton.Background 
          icon="trashCan" 
          type="secondary"
          onClick={() => onDelete?.(idx)}
        />
      </ButtonContainer>
    </Container>
  );
};

export default ComplainCategory;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;